import { render } from "./Notifier.vue?vue&type=template&id=1b612a4e&scoped=true"
import script from "./Notifier.vue?vue&type=script&lang=js"
export * from "./Notifier.vue?vue&type=script&lang=js"

import "./Notifier.vue?vue&type=style&index=0&id=1b612a4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b612a4e"]])

export default __exports__